import RouterStore from "@/store/RouterStore";
import Ambiente from "../utils/Ambiente";

class Configuracao {

    urlCategoriasMinuta = '';

    urlSessao;
    urlBackendMinuta;
    urlBackendEsijGabinete;

    contadorBackendMinuta = 1;
    contadorlBackendGE = 1;


    constructor(_ambiente?) {

        if (process.env.NODE_ENV === 'local') {
            this.urlSessao = '/pje-servicos/api/';
            this.urlBackendMinuta = '/pje-servicos-minuta/api/';
            this.urlBackendEsijGabinete = '/esij-backend-gabinete/api/';
        } else {
            this.urlSessao = '/pje-sessao-julgamento/';
            this.urlBackendMinuta = '/pje-minuta/';
            this.urlBackendEsijGabinete = '/esij-gabinete/';
        }
    }



    get urlUsuariosGE() {
        return this.urlBaseGE + 'api/usuarios/'
    }

    get urlBaseMinuta() {
        const dominios = Ambiente.urlBackendMinuta.split(";");

        if (this.contadorBackendMinuta >= dominios.length) {
            this.contadorBackendMinuta = 0;
        }
        return dominios[this.contadorBackendMinuta++]
    }

    get urlWebDAV() {
        return Ambiente.urlWebDAV;
    }

    get urlEnvelope() {
        return Ambiente.urlEnvelope;
    }

    get urlBaseGE() {
        const dominios = Ambiente.urlBackendGE.split(";");

        if (this.contadorlBackendGE >= dominios.length) {
            this.contadorlBackendGE = 0;
        }
        return dominios[this.contadorlBackendGE++]
    }

    get urlConsultaLiberacaoVoto() {
        return this.urlBaseGE + 'api/minutas/voto/{ID_PROCESSO}/liberacao-consulta';
    }

    get urlDownloadMinutasGe() {
        return this.urlBaseGE + 'api/minutas/download-geJobs?urlGeJobs=';
    }

    get urlVotacaoVirtual() {
        return this.urlBaseGE + 'api/minuta/votacao-virtual';
    }

    get urlConsultarVotacaoVirtual() {
        return this.urlBaseGE + 'api/minuta/votacao-virtual/consultar';
    }

    get urlInfoToken() {
        return this.urlBaseGE + 'api/usuarios/token/info';
    }
    get urlIniciarProcessamentoParaDownload() {
        return this.urlBaseGE + 'api/minutas/download/';
    }

    get urlConsultarEstadoProcessamentoDownload() {
        return this.urlBaseGE + 'api/minutas/download/';
    }

    get urlDownload() {
        return this.urlBaseGE + 'api/minutas/download/';
    }

    get urlVersaoPje() {
        return this.urlBaseGE + 'api/si/versoes';
    }

    get urlArquivarMinutas() {
        return this.urlBaseGE + 'api/minutas/arquivar';
    }

    get urlBuscaPartesProcessoFiltro() {
        return this.urlBaseGE + 'api/processos/partes-busca/';
    }

    get urlMinutaGE() {
        return this.urlBaseGE + 'api/minutas/';
    }

    get urlDevolverMinutasEManterAssinatura() {
        return this.urlBaseGE + 'api/minuta/devolver-secretaria/cpf/{CPF_DO_USUARIO}/manter-assinatura/';
    }

    get urlCategoriaMinuta() {
        return this.urlBaseGE + 'api/minutas/{ID_PROCESSO}/{ID_TIPO_MINUTA}/categorias/';
    }

    get idProcesso() {
        return "{ID_PROCESSO}";
    }
    get tipoMinuta() {
        return "{ID_TIPO_MINUTA}";
    }
    get idPeticao() {
        return "{ID_PETICAO}";
    }

    get urlMinutaEmEdicaoExterna() {
        return this.urlBaseGE + 'api/minutas/emEdicaoExterna';
    }

    get urlTiposMinuta() {
        return this.urlBaseGE + 'api/tipos-minuta/';
    }

    get urlSituacoesMinuta() {
        return this.urlBaseGE + 'api/situacoes-minuta/';
    }

    get urlSituacoesPeticao() {
        return this.urlBaseGE + 'api/situacoes-peticao/';
    }

    get urlAlterarSituacaoPeticao() {
        return this.urlBaseGE + 'api/processos/{ID_PROCESSO}/peticoes/{ID_PETICAO}/situacoes';
    }

    get urlApreciarPeticao() {
        return this.urlBaseGE + 'api/processos/{ID_PROCESSO}/peticoes/{ID_PETICAO}/apreciar';
    }

    get urlDesapreciarPeticao() {
        return this.urlBaseGE + 'api/processos/{ID_PROCESSO}/peticoes/{ID_PETICAO}/desapreciar';
    }



    get urlModelosMinuta() {
        return this.urlBaseGE + 'api/modelo-minuta/{COD_MODELO}';
    }

    get urlModelosMinutaDelete() {
        return this.urlBaseGE + 'api/modelo-minuta/{COD_MODELO}';
    }

    get urlCountMinutasDevolvidas() {
        return this.urlBaseGE + 'api/processo-controle-gabinete/{gabinete}/count-minutas-devolvidas';
    }

    get urlProcessoTarefaFluxoJbpmPje() {
        return this.urlBaseGE + 'api/fluxo/buscarNoTarefaFluxoJbpm/';
    }

    get urlBuscarModelosMinuta() {
        return this.urlBaseGE + 'api/modelo-minuta/{GABINETE}/{TIPO_MINUTA}/buscar';
    }


    get urlMovimentosMinuta() {
        return this.urlBaseGE + 'api/minuta-movimento';
    }

    get urlOpcoesDeComplementoDeMovimentoDeProcesso() {
        return this.urlBaseGE + 'api/minuta-movimento/movimento/{COD_MOVIMENTO}/processo/{ID_PROCESSO}';
    }

    get urlUsuarioGE() {
        return this.urlBaseGE + 'api/usuario';
    }

    get urlMovimentoProcessualLegadoPJe() {
        return this.urlBaseGE + 'api/movimentos';
    }

    get urlTiposControlesGabinete() {
        return this.urlBaseGE + 'api/tipos-controle-gabinete/';
    }



    get urlQtdProcessosPorControlesGabinete() {
        return this.urlBaseGE + 'api/controles-gabinete/qtd-processos';
    }

    get urlControlesGabineteGE() {
        return this.urlBaseGE + 'api/controles-gabinete/';
    }

    //RECOLOCADO PQ DEU PAU NO SERVIÇO MIGRADO
    get urlControlesGabineteAntigo() {
        return this.urlBaseMinuta + 'controles-gabinete/';
    }


    get urlEnviarParaPauta() {
        return this.urlBaseGE + 'api/minuta/{ID_PROCESSO}/{SIGLA_GABINETE}/enviarParaPauta';
    }

    get urlImpedimentos() {
        return this.urlBaseGE + 'api/processos/impedimentos/{siglaOJ}';
    }

    get urlProcessosGE() {
        return this.urlBaseGE + 'api/processos/';
    }

    get urlProcessosComAgProvido() {
        return this.urlBaseGE + 'api/processos/ag-provido';
    }

    get urlConsultaEtiquetas() {
        return this.urlBaseGE + 'api/processos/etiquetas/';
    }

    get urlDadosMinutaAssinar() {
        return this.urlBaseGE + 'api/assinatura/minuta-para-assinar/';
    }
    get urlDadosPreviewVersaoMinuta() {
        return this.urlBaseGE + 'api/assinatura/versoes-preview/';
    }

    get urlAssinarOTPEmLote() {
        return this.urlBaseGE + 'api/assinatura/salvarComOtpEmLote';
    }
    get urlEnviarAssinatura() {
        return this.urlBaseGE + 'api/assinatura/salvar';
    }

    get urlPrioridades() {
        return this.urlBaseGE + 'api/indicadores/';
    }
    get urlBuscarUltimaPauta() {
        return this.urlBaseGE + 'api/processos/ultima-inclusao-pauta';
    }
    get urlIndicadores() {
        return this.urlBaseGE + 'api/indicadores/';
    }

    get urlConversorMinuta64toHtml() {
        return this.urlConversorMinuta + 'base64-to-html';
    }

    get urlParametrosMinuta() {
        return this.urlBaseGE + 'api/parametros';
    }

    get urlParametrosUsuario() {
        return this.urlBaseGE + 'api/parametro-usuario';
    }

    get urlClasses() {
        return this.urlBaseGE + 'api/classes';
    }

    get urlMotivosImpedimento() {
        return this.urlBaseGE + 'api/parametros/motivos-impedimento';
    }

    get urlTiposDocumentoProcesso() {
        return this.urlBaseGE + 'api/peticao/tiposDocs';
    }
    get urlGetImportacao() {
        return this.urlBaseGE + 'api/processos?importado=false&gabinete={SIGLA_GABINETE}';
    }

    get urlGetFavoritos() {
        return this.urlBaseGE + 'api/processos/favoritos';
    }

    get urlFazerImportacao() {
        return this.urlBaseGE + 'api/processos/importar';
    }

    get urlProcessosImportados() {
        return this.urlBaseGE + 'api/processos/importados?codImportacao={COD_IMPORTACAO}';
    }

    get urlHistorico() {
        return this.urlBaseGE + 'api/processos/historicos?';
    }

    get urlSalvarCategoriasNasMinutas() {
        return this.urlBaseGE + 'api/minutas/categorias/';
    }

    get urlGraphql() {
        return this.urlBaseGE + 'graphql';
    }

    get urlSalvarTriagem() {
        return this.urlBaseGE + 'api/processos/triagem-livre?';
    }

    get urlEtiquetasOrigem() {
        return this.urlBaseGE + 'api/processos/etiquetas-origem';
    }

    get urlBaixarInteiroTeor() {
        return this.urlBaseGE + 'api/processos/{ID_PROCESSO}/inteiro-teor';
    }

    get urlTriagemLivre() {
        return this.urlBaseGE + 'api/processos/consulta-triagem-livre';
    }

    get urlLiberarConteudoVotoEmLote() {
        return this.urlBaseGE + 'api/minuta/liberar-voto';
    }

    get urlCancelarLiberacaoConteudoVotoEmLote() {
        return this.urlBaseGE + 'api/minuta/cancelar-liberacao-voto';
    }

    get urlMotivosAndamento() {
        return this.urlBaseGE + 'api/motivos-andamento-legado';
    }

    get urlProcGabPeticao() {
        return this.urlBaseGE + 'api/peticoes-pendentes/{SIGLA_GABINETE}';
    }
    get urlProcGabPeticaoPorProcesso() {
        return this.urlBaseGE + 'api/peticoes/escaninho/id/{ID_PROCESSO}';
    }

    get urlReceberNotificacao() {
        return this.urlEnvelope + 'cometd'
    }

    get urlSituacaoMinuta() {
        return this.urlBaseGE + 'api/minutas/{NUM_MINUTA}/{CODIGO_SITUACAO}/alterar-situacao'
    }

    get urlSituacaoMinutaEmLote() {
        return this.urlBaseGE + 'api/minutas/situacao/{CODIGO_SITUACAO}/alterar-situacao'
    }

    get urlTranformarAgravoEmVoto() {
        return this.urlBaseGE + 'api/minuta/tranformarFuturoEmVoto';
    }

    get urlOrgaoJulgador() {
        return this.urlBaseGE + 'api/orgaosjulgadores/sigla-oj/'
    }

    get urlDadosBemTeVi() {
        return this.urlBaseGE + 'api/btv'
    }

    get urlResumoConsolidadoDocumentosAguia() {
        return this.urlBaseGE + 'api/aguia/processos/{ID_PROCESSO}/resumo-documentos-consolidado';
    }

    get urlFeedbackAguia() {
        return this.urlBaseGE + 'api/aguia/processos/{ID_PROCESSO}/feedback';
    }

    get urlMsConsultaUsuarios() {
        return this.urlBaseGE + 'api/usuarios/';
    }
    get urlPecasFiltradas() {
        return this.urlBaseGE + 'api/documentos/{IDPROCESSO}/pecas-filtradas';
    }

    get urlVariaveisDeModelo() {
        return this.urlBaseGE + 'edicaoDeMinutas/processo/{NUMERO_PROCESSO}/variaveisDeModelo?var={VARIAVEL}';
    }

    //MANTEM
    get urlUsuarios() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'usuarios/';
        }
        return this.urlBaseGE + 'api/usuarios/';
    }

    //MANTEM
    get urlMinuta() {
        return this.urlBaseMinuta + 'minutas/';
    }

    //MANTEM
    get urlDocumentos() {
        return this.urlBaseGE + 'api/documentos/';
    }

    //MANTEM
    get urlProcessos() {
        return this.urlBaseMinuta + 'processos/';
    }

    //MIGRADO
    get urlContinuarAssinatura() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'assinatura/continuarAssinatura/';
        }

        return this.urlBaseGE + 'api/assinatura/continuarAssinatura/';
    }
    //MIGRADO
    get urlRefinalizarAssinatura() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'assinatura/refinalizarAssinatura/';
        }
        return this.urlBaseGE + 'api/assinatura/refinalizarAssinatura/';
    }

    //MIGRADO
    get urlTokenOTP() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'assinatura/tokenOtp';
        }
        return this.urlBaseGE + 'api/assinatura/tokenOtp';
    }

    //MIGRADO
    get urlConversorMinuta() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'conversor/';
        }
        return this.urlBaseGE + 'api/conversor/';
    }

    //MANTEM
    get urlFiltrosRapidos() {
        return this.urlBaseMinuta + 'filtros-rapidos/';
    }

    //MANTEM
    get urlFiltrosRapidosGE() {
        return this.urlBaseGE + 'api/filtros-rapidos/';
    }

    //MIGRADO
    get urlRecuperarEmentaDecisao() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'minutas/voto/ementa-decisao'
        }
        return this.urlBaseGE + 'api/minutas/voto/ementa-decisao'
    }

    //MANTEM
    get urlModelosMinutaPadrao() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'modelos-padrao/';
        }
        return this.urlBaseGE + 'api/modelos-padrao/';
    }

    //MANTEM
    get urlProcessosSessao() {
        return this.urlBaseMinuta + 'processos/';
    }

    //MANTEM
    get urlIdProcessoPorNumero() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'processos/numero/'
        }

        return this.urlBaseGE + 'api/processos/numero/';
    }

    //MIGRADO
    get urlModelosMinutaAntigo() {
        if (RouterStore.isPrd) {
          return this.urlBaseMinuta + 'modelos/';
        }
        return this.urlBaseGE + 'api/modelos/';
    }

    //MANTEM
    get urlHealthCheckMinuta() {
        return this.urlBaseMinuta + 'health-check';
    }

    get urlHealthCheckBackendGE() {
        return this.urlBaseGE + 'health-check'
    }

    //MANTEM
    get urlMinutasExternas() {
        if (RouterStore.isPrd) {
            return this.urlBaseMinuta + 'minutas-externas/';
        }
        return this.urlBaseGE + 'api/minutas-externas/';
    }

    get urlGerarEmentaAguia() {
        return this.urlBaseGE + 'api/aguia/minutas/{NUM_MINUTA}/gerarEmenta';
    }

    get urlSubstituirEmentaAguia() {
        return this.urlBaseGE + 'api/aguia/minutas/{NUM_MINUTA}/substituirEmenta';
    }

    get urlExcluirMinutaAguia() {
        return this.urlBaseGE + 'api/aguia/minutas';
    }

    get urlRecuperarMinutaArquivada() {
        return this.urlBaseGE + 'api/minutas/{NUM_MINUTA}/recuperar-minuta-arquivada';
    }

    get urlJurisprudencia() {
        return "https://jurisprudencia-backend2.tst.jus.br/rest/pesquisa-textual/1/20";
    }

    get urlDocJurisprudencia() {
        return "https://jurisprudencia-backend2.tst.jus.br/rest/documentos/{IDJURISPRUDENCIA}";
    }

    get urlBuscarProcessosPautasFuturas() {
        return this.urlBaseGE + 'api/controles-gabinete/{ORGAO_JULGADOR}/processos-pautas-futuras';
    }

}

export default new Configuracao();
